export { ClipboardCopy as default } from './ClipboardCopy';
